module.exports = __webpack_public_path__ + "static/media/wifi.700b6d0b.png";